import { Link } from "react-router-dom";
import { ArrowRight, Lock } from "lucide-react";
import { ESCUELAS_LIST } from "../data/escuelas";

export default function HubEscuelas() {
    return (
        <div data-testid="hub-escuelas" className="pt-32 pb-24 min-h-screen relative overflow-hidden">
            <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-unemi-orange-primary/10 rounded-full blur-[120px] pointer-events-none" />
            <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-unemi-blue-light/5 rounded-full blur-[150px] pointer-events-none" />
            
            <section className="max-w-7xl mx-auto px-6 md:px-10 relative z-10">
                <div className="max-w-3xl">
                    <p className="text-xs uppercase tracking-[0.22em] font-bold text-unemi-orange-primary">
                        Posgrados UNEMI · 2026
                    </p>
                    <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white mt-3 leading-[1.05]">
                        Elige tu{" "}
                        <span className="italic text-unemi-orange-light">escuela</span> y
                        descubre tu próxima maestría.
                    </h1>
                    <p className="mt-5 text-base md:text-lg text-slate-300 leading-relaxed">
                        Cinco escuelas, decenas de programas acreditados, una sola universidad
                        comprometida con tu crecimiento profesional.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-16">
                    {ESCUELAS_LIST.map((e, i) => (
                        <Link
                            key={e.slug}
                            to={`/${e.slug}`}
                            data-testid={`hub-card-${e.slug}`}
                            style={{ animationDelay: `${i * 80}ms` }}
                            className={
                                "opacity-0 animate-fade-up bg-white border border-slate-200/50 rounded-2xl p-7 transition-all duration-300 group flex flex-col justify-between min-h-[260px] " +
                                (e.activa
                                    ? "hover:-translate-y-1 hover:shadow-2xl hover:shadow-white/10 hover:border-unemi-blue-light/40"
                                    : "opacity-80 grayscale-[30%]")
                            }
                        >
                            <div>
                                <p className="text-[10px] uppercase tracking-[0.22em] font-bold text-unemi-orange-primary">
                                    Escuela
                                </p>
                                <h3 className="font-heading text-2xl text-unemi-blue-dark group-hover:text-unemi-blue-primary transition-colors mt-3 leading-snug">
                                    {e.nombreCorto}
                                </h3>
                                <p className="text-sm text-slate-500 mt-2">
                                    {e.nombreCompleto}
                                </p>
                            </div>
                            <div className="mt-7 flex items-center justify-between">
                                {e.activa ? (
                                    <>
                                        <span className="inline-flex items-center gap-1.5 bg-unemi-orange-primary/10 text-unemi-orange-primary font-bold px-3 py-1 rounded-full text-[10px] uppercase tracking-wider">
                                            <span className="w-1.5 h-1.5 rounded-full bg-unemi-orange-primary animate-pulse" />
                                            Inscripciones abiertas
                                        </span>
                                        <span className="grid place-items-center w-11 h-11 rounded-full bg-unemi-blue-primary text-white group-hover:bg-unemi-orange-primary group-hover:rotate-45 transition-all shadow-md">
                                            <ArrowRight className="w-4 h-4" />
                                        </span>
                                    </>
                                ) : (
                                    <>
                                        <span className="inline-flex items-center gap-1.5 bg-slate-100 text-slate-500 font-bold px-3 py-1 rounded-full text-[10px] uppercase tracking-wider">
                                            <Lock className="w-3 h-3" />
                                            Próximamente
                                        </span>
                                        <span className="text-xs text-slate-400 font-semibold">
                                            En preparación
                                        </span>
                                    </>
                                )}
                            </div>
                        </Link>
                    ))}
                </div>
            </section>
        </div>
    );
}
